// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
import InvestingPasswordTextBoxTemplate from '../../TradingPlatformTemplates/InvestingPasswordTextBoxTemplate.html';
import { PasswordTextBox } from '@front/controls/elements/PasswordTextBox';
export class InvestingPasswordTextBox extends PasswordTextBox {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.InvestingPasswordTextBox;
    }
}
PasswordTextBox.extendWith(InvestingPasswordTextBox, {
    template: InvestingPasswordTextBoxTemplate,
    data: function () {
        return {
            showPasswordPreview: false,
            passwordHided: true,
            focused: false,
            showPassEyeTooltip: '',
            hidePassEyeCrossedTooltip: ''
        };
    }
});
